import { Button, FormControl, FormLabel, OutlinedInput } from '@mui/material';
import { ObjectContainerClientT } from 'bovaljaren-models';
import React, { ReactElement, useContext, useState } from 'react';
import { AppContext } from '../../../../../state/app.state';
import { isMobile } from '../../../../../utils/app.helper';
import './ObjectViewInterestForm.scss';

type ObjectViewInterestFormProps={
    showInterestForm: boolean;
    selectedObject?: ObjectContainerClientT
    onClose?: () => void;
};

const ObjectViewInterestForm: React.FC<ObjectViewInterestFormProps> = ({ showInterestForm, selectedObject, onClose }): ReactElement => {
    const { state } = useContext(AppContext);
    const [formState, setFormState] = useState<{[key: string]: string}>({});

    const replaceBody = (body: string) => {
        let bodyParsed = decodeURIComponent(body);

        formState && Object.entries(formState).forEach(oE => {
            bodyParsed = bodyParsed.replaceAll(`{{${oE[0]}}}`, oE[1]);
        });
        bodyParsed = bodyParsed.replaceAll('{{objektTyp}}', state?.project?.objectTypes.find(oT => oT.id === selectedObject?.objectTypeId)?.name || '');
        bodyParsed = bodyParsed.replaceAll('{{objektNamn}}', selectedObject?.name || '');
        bodyParsed = bodyParsed.replaceAll('{{projektNamn}}', state?.project?.name || '');

        return encodeURIComponent(bodyParsed);

    };
    const replaceSubject = (body: string) => {
        let bodyParsed = decodeURIComponent(body);

        bodyParsed = bodyParsed.replaceAll('{{objektTyp}}', state?.project?.objectTypes.find(oT => oT.id === selectedObject?.objectTypeId)?.name || '');
        bodyParsed = bodyParsed.replaceAll('{{objektNamn}}', selectedObject?.name || '');
        bodyParsed = bodyParsed.replaceAll('{{projektNamn}}', state?.project?.name || '');

        return encodeURIComponent(bodyParsed);

    };
    const submit = (event: any) => {
        if (!state?.project?.interestForm) return;

        const link = document.createElement('a');
        link.id = 'mail-to';

        const { mail, subject, body } = state.project?.interestForm;
        link.href = `mailto:${mail}?subject=${replaceSubject(subject) || ''}&body=${replaceBody(body) || ''}`;
        link.target = '_top';
        link.className = 'noHighlight';
        link.addEventListener('click', () => {
            event.preventDefault();

            return false;
        });
        link.click();
        link.remove();
        onClose && onClose();
    };

    const onChange = (field: string): React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement> => {
        return (evt) => {
            const tempState = formState;
            tempState[field] = evt.target.value;
            setFormState(tempState);
        };
    };
    function onlyUnique(value: string, index: number, array: string[]) {
        return array.indexOf(value) === index;
    }

    return (
        showInterestForm ? <div className={'bv-doc-center'} style={{ marginTop: '10% !important' }}>
            <div className={'bv-doc-wrapper'}>
                <h2 className="bv-doc-header">Intresseanmälan</h2>
                <form onSubmit={(e): void => (!isMobile() && submit(e)) || undefined}>
                    {state?.project?.interestForm?.body && decodeURIComponent(state?.project?.interestForm?.body).split(/{{([^{]*)}}/)
                        .filter(s => /^[A-ZÅÄÖa-zåäö\s]*$/.test(s) && s.split(' ')?.length <= 2)
                        .filter(str => str !== 'objektNamn' && str !== 'projektNamn' && str !== 'objektTyp')
                        .filter(s => {
                            return s.replace(' ', '').length;
                        })
                        .filter(onlyUnique)
                        .map(str => {
                            return <FormControl key={str} className={'bv-form-control-textfield'}>
                                <FormLabel>{str}</FormLabel>
                                <OutlinedInput
                                    value={formState ? formState[str] : ''}
                                    onChange={onChange(str)}
                                    fullWidth
                                />
                            </FormControl>;
                        })}
                    <Button type="submit" onClick={(isMobile() && submit) || undefined} className='bv-sumbit-if' variant="outlined" style={{ height: '3rem', marginTop: '0.25rem', border: '1px solid lightgrey', borderRadius:'0.25rem', padding: '0.25rem' }}>Anmäl intresse</Button>
                </form>
            </div>
        </div> : <></>
    );
};


export default ObjectViewInterestForm;